module.exports = __webpack_public_path__ + "img/kerstin-f51d706.jpg";